import React from 'react';
import {
  createStyles,
  Theme,
  withStyles,
  TableCellProps,
} from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyMediumBold from 'ui-elements/typography/FsBodyMediumBold';
import FsBodyExtraSmallBold from 'ui-elements/typography/FsBodyExtraSmallBold';
import { FsComponentSize } from 'globals/types';
import { getRowPaddingRelativeValue } from './FsSimpleTable.style';

export const Value = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      background: palette.grey[100],
      padding: spacing(0.3, 1),
      borderRadius: 4,
    },
  })
)((props) => <FsBodyMediumBold component="span" {...props} />);

export const HeadValue = withStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      color: palette.grey[400],
    },
  })
)((props) => <FsBodyExtraSmallBold component="span" {...props} />);

export const Name = withStyles({})((props) => (
  <FsBody component="span" {...props} />
));

interface CustomTableCellProps {
  withBorder?: boolean;
  rowSize?:
    | FsComponentSize.XS
    | FsComponentSize.S
    | FsComponentSize.M
    | FsComponentSize.L;
  isLast?: boolean;
}

export const CustomTableCell = withStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      borderBottom: `1px solid ${palette.grey[200]}`,
    },
  })
)(
  ({
    rowSize,
    withBorder,
    isLast,
    ...otherProps
  }: TableCellProps & CustomTableCellProps) => (
    <TableCell
      {...otherProps}
      style={{
        padding: rowSize ? getRowPaddingRelativeValue(rowSize) : undefined,
        borderBottom: isLast || !withBorder ? 0 : undefined,
      }}
    />
  )
);
